import { DataShopTable } from "@okeys/shared-utils"
import { getPrestateres } from "./getPrestateres"

/**
 * Récupère un prestataire spécifique par son ID depuis les données du shop
 * @param dataShop - Les données du shop contenant tous les prestataires
 * @param prestatereId - L'ID du prestataire à récupérer
 * @returns Le prestataire trouvé ou undefined si non trouvé
 */
export const getPrestatere = (
  dataShop: DataShopTable,
  prestatereId: string
) => {
  const allPrestateres = getPrestateres(dataShop)
  return allPrestateres.find((prestatere) => prestatere.id === prestatereId)
}
